import Model from './Model';

export default class MailIntegration extends Model {
  resource() {
    return 'mail_integration';
  }
}
